import React, { useEffect, useState } from "react";
import getModalStyle from "../../../../util/getModalStyle";
import { getGlassOrderSheet } from "../../../../api/DzoneApi";
import { QuoteObj, UserObj, Overwrite } from "../../../../GlobalTypes";
import createDownloadLink from "../../../../util/createDownloadLink";

type AdminQuoteObj = Overwrite<QuoteObj, { userId: UserObj }>;

interface CustomUnits {
  quoteNumber: number;
  salesOrder: string;
  partNumber: number;
  type?: string;
}

function useGlassOrderSelector(quote?: AdminQuoteObj[], open?: boolean) {
  const [modalStyle] = useState(() => getModalStyle(50, 50));

  const [date, setDate] = useState("");

  const [customUnits, setCustomUnits] = useState<CustomUnits[]>([]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setDate(value);
  };

  useEffect(() => {
    if (open) return;
    setDate("");
    setCustomUnits([]);
  }, [open]);

  useEffect(() => {
    if (!quote || !quote.length || !date) return;

    async function getGlassData() {
      const quoteIds = quote?.map((q) => q._id);
      try {
        if (!quoteIds) throw new Error("no quote ids");

        const res = await getGlassOrderSheet(quoteIds, date);

        if (!res.data) return;

        if (!res.data.glassData.length) {
          return setCustomUnits(res.data.customGlass);
        }

        // Convert base64-encoded buffer to Uint8Array
        const uint8Array = new Uint8Array(
          atob(res.data.glassData)
            .split("")
            .map((char) => char.charCodeAt(0))
        );

        // Create a Blob and trigger the download
        const excelBlob = new Blob([uint8Array], {
          type: "text/csv",
        });

        const today = new Date();

        createDownloadLink(
          excelBlob,
          `GlassOrder${today.toLocaleDateString("en-US")}.csv`
        );

        setCustomUnits(res.data.customGlass);
      } catch (err) {
        console.log(err);
      }
    }

    getGlassData();
  }, [quote, date]);

  return {
    customUnits,
    modalStyle,
    handleChange,
    date
  };
}

export default useGlassOrderSelector